import React from 'react'

type PendingDocIconProps = {
  width?: number | string
  height?: number | string
  className?: string
  color?: string
}

export const PendingDocIcon = ({ width = 20, height = 20, className, color = 'currentColor' }: PendingDocIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16.6544 13.5131H14.3247C13.4042 13.5131 12.658 14.2593 12.658 15.1798V17.5196C12.658 18.5466 13.0324 18.7612 13.0848 18.7086L17.9162 13.9727C17.9686 13.9201 17.4231 13.5777 16.6544 13.5131Z"
      fill={color}
    />
    <path
      d="M6.57026 6.82718C6.57026 7.28741 6.19717 7.66051 5.73693 7.66051C5.27669 7.66051 4.9036 7.28741 4.9036 6.82718C4.9036 6.36694 5.27669 5.99384 5.73693 5.99384C6.19717 5.99384 6.57026 6.36694 6.57026 6.82718Z"
      fill={color}
    />
    <path
      d="M6.57023 10C6.57023 10.4602 6.19714 10.8333 5.7369 10.8333C5.27666 10.8333 4.90356 10.4602 4.90356 10C4.90356 9.53976 5.27666 9.16667 5.7369 9.16667C6.19714 9.16667 6.57023 9.53976 6.57023 10Z"
      fill={color}
    />
    <path
      d="M8.75305 6.82715H12.5137M8.75305 9.99997H14.366M17.5056 13.9137V3.33331C17.5056 2.41283 16.7594 1.66664 15.8389 1.66664H4.16117C3.2407 1.66664 2.49451 2.41283 2.49451 3.33331V16.6666C2.49451 17.5871 3.2407 18.3333 4.16117 18.3333H13.0848C13.1069 18.3333 13.1281 18.3245 13.1438 18.3089L17.4812 13.9726C17.4968 13.957 17.5056 13.9358 17.5056 13.9137Z"
      stroke={color}
      strokeWidth={1.2}
      strokeLinecap="round"
    />
  </svg>
)
